import axios from "@/utils/index.js";
import {
    isPro,
    proUrl,
    uatUrl
} from "./config.js";
import { ELECTRONIC_PRIVACY_ID } from "@/utils/enum.js";
import moment from "moment";

class loginApi {
    // 最新协议内容及版本查询
    lastProtocol() {
        return axios.get(`${isPro ? (proUrl + '/ecro') : (uatUrl + '/object')}` + `/jg/contract/${ELECTRONIC_PRIVACY_ID}.json?_t=${moment().format('YYYYMMDD')}`, {
            _noCheck: true,
            withCredentials: false // 跨域请求s是否需要携带登录 Cookie 以验证身份
        })
    }
}

export default new loginApi();
